import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'
import { useVerifyDiscord } from '@modules/Dashboard/pages/Apps/pages/AppsDiscordVerification'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'VERIFY_DISCORD' }>
}

export const DiscordIncentive = ({ incentive }: Props) => {
  const { alreadyVerified, openVerificationLink } = useVerifyDiscord()
  const { tablet } = useMediaQueryContext()

  return (
    <Incentive
      type={incentive.type}
      icon="🤖"
      label="Join our Discord"
      isCompleted={incentive.isCompleted || alreadyVerified}
      bonus={getBonus(incentive.bonus)}
      button={{
        label: tablet ? 'Join Discord' : 'Join',
        onClick: openVerificationLink,
      }}
    />
  )
}
